import { BellOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { Popover } from 'sutra/components'

// Panel-level presentation for the notifications bell + dropdown —
// split out of NotificationsPanelView so the view file stays focused on
// structure. Row-level styles live with NotificationRow.

const PANEL_WIDTH = 380
const PANEL_MAX_HEIGHT = 480

// Mirrors TooltipIconButton's default-variant IconButton so the bell reads as
// one control group with the Signout button beside it.
export const BellButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  padding: 0;
  border: none;
  border-radius: 6px;
  font: inherit;
  background: transparent;
  color: #5072a4;
  cursor: pointer;
  transition:
    background 0.2s ease,
    color 0.2s ease;

  &:hover {
    background: #5072a426;
    color: #28364f;
  }
`

export const BellIcon = styled(BellOutlined)`
  font-size: 18px;
`

export const ErrorIcon = styled(ExclamationCircleOutlined)`
  font-size: 24px;
`

export const Panel = styled.div`
  width: ${PANEL_WIDTH}px;
  background: #ffffff;
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  overflow: hidden;
`

export const PanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #e3e3e3;
  background: #fafafa;
`

export const HeaderTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const PanelTitle = styled.span`
  font-weight: 600;
  font-size: 14px;
`

export const UnreadCountLabel = styled.span`
  font-size: 12px;
  color: #5072a4;
`

export const PanelBody = styled.div`
  max-height: ${PANEL_MAX_HEIGHT}px;
  overflow-y: auto;
`

export const SkeletonWrapper = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const EmptyWrapper = styled.div`
  padding: 24px 16px;
  color: #595959;
`

export const ErrorState = styled.div`
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #595959;
`

export const HeaderControls = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const UnreadToggleLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #595959;
  cursor: pointer;
`

export const LoadMoreRow = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px 16px;
`

// The panel brings its own box, so the Popover popup's is stripped.
export const PanelPopover = styled(Popover)`
  && {
    padding: 0;
    background: transparent;
    box-shadow: none;
  }
`

// The tooltip's trigger. It wraps the Popover rather than sitting between the
// Popover and the button: a Sutra Tooltip directly around a Popover loses the
// Popover's trigger handlers.
export const TooltipAnchor = styled.span`
  display: inline-flex;
`
